/* AYNOHA — JS propio. Vanilla, sin librerías. */
(function () {
  'use strict';

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.ay-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ay-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ay-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: si algo falla, mostrar todo tras 1.4s
    setTimeout(function () { els.forEach(function (el) { el.classList.add('ay-in'); }); }, 1400);
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gal = document.querySelector('[data-ay-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-ay-main]');
    var thumbs = gal.querySelectorAll('[data-ay-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src && main) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var form = document.querySelector('[data-ay-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-ay-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-ay-option]');
    if (!selects.length) return; // producto de variante única: deja el precio del servidor
    var idInput = form.querySelector('[data-ay-variant-id]');
    var priceEl = document.querySelector('[data-ay-price]');
    var atc = form.querySelector('[data-ay-atc]');
    var moneyFmt = form.getAttribute('data-money') || '${{amount}}';

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function chosen() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function update() {
      var v = chosen();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += ' <s>' + money(v.compare_at_price) + '</s>';
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          html += ' <span class="ay-save">-' + pct + '%</span>';
        }
        priceEl.innerHTML = html;
      }
      if (atc) {
        if (v.available) { atc.disabled = false; atc.querySelector('[data-ay-atc-label]').textContent = atc.getAttribute('data-label-add'); }
        else { atc.disabled = true; atc.querySelector('[data-ay-atc-label]').textContent = atc.getAttribute('data-label-sold'); }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ---- Marquee: duplica el contenido para bucle continuo ---- */
  function initMarquee() {
    document.querySelectorAll('[data-ay-marquee]').forEach(function (track) {
      if (track.getAttribute('data-cloned')) return;
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-cloned', '1');
    });
  }

  /* ---- Selector de pack (1 / 2 unidades) ---- */
  function initPacks() {
    var packs = document.querySelectorAll('[data-ay-pack]');
    if (!packs.length) return;
    var qtyInput = document.querySelector('[data-ay-qty]');
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        if (qtyInput) qtyInput.value = p.getAttribute('data-qty') || '1';
      });
    });
  }

  function init() {
    initReveals();
    initGallery();
    initVariants();
    initMarquee();
    initPacks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
